var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterValve({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33075 29.8532H16.1938C17.5694 28.0191 19.314 26.6277 21.2584 25.6792M7.33075 29.8532V24.7886H1V52.6439H7.33075V48.8455M7.33075 29.8532V48.8455M49.1137 29.8532H40.2506C35.4483 24.0905 27.3675 22.6991 21.2584 25.6792M49.1137 29.8532V24.7886H55.4444V52.6439H49.1137V48.8455M49.1137 29.8532V48.8455M49.1137 48.8455H40.2506C33.9199 57.0754 22.5245 57.0754 16.1938 48.8455H7.33075M21.2584 25.6792V20.9902H25.0568M33.9199 25.6792V20.9902H31.3876M31.3876 20.9902V11L41.5168 12.1271C46.5814 12.1271 46.5814 5.79635 41.5168 5.79635L31.3876 7.11111M31.3876 20.9902H25.0568M25.0568 20.9902V11L14.9276 12.1271C9.86305 12.1271 9.86305 5.79635 14.9276 5.79635L25.0568 7.11111M25.0568 7.11111V2.66659C25.0568 0.444315 31.3876 0.444315 31.3876 2.66659V7.11111M25.0568 7.11111H28.2222H31.3876",
    stroke: "#F57F20",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterValve);
export default __webpack_public_path__ + "static/media/WaterValve.a3bfc9f5e9289ed30e2abed57f8eb26c.svg";
export { ForwardRef as ReactComponent };